<template>
    <div class="footer__contacts mb-0">
        <div class="footer__contacts-item">
            {{ company }}, {{ address }}, {{ country }}
        </div>
        <div class="footer__contacts-item">Registration number: {{ regNum }}</div>
        <div class="footer__contacts-item">VAT: {{ vatNum }}</div>
    </div>
    <div class="footer__contacts mt-3">
        <div class="footer__contacts-item">
            Email: <a :href="`mailto:${mailTo}`">{{ mailTo }}</a>
        </div>
        <div class="footer__contacts-item">
            Telephone: <a :href="`tel:${phone}`">{{ phone }}</a>
        </div>
        <div class="footer__contacts-item">Customer Support 24/7</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            company: import.meta.env.VITE_COMPANY,
            address: import.meta.env.VITE_ADDRESS,
            country: import.meta.env.VITE_COUNTRY,
            regNum: import.meta.env.VITE_REG_NUM,
            phone: import.meta.env.VITE_PHONE,
            mailTo: import.meta.env.VITE_MAILTO,
            vatNum: import.meta.env.VITE_VAT_NUM,
        };
    },
};
</script>
